// 이 파일은 scripts/export-legacy-course-display.mjs 가 만든다. 직접 고치지 않는다.
// 레거시 /lecture/ 목록만 쓰던 표시 값(사용 과정 138건): 과정 코드 → [레거시 seq, 모바일 학습(1/0), 교육비 selfPrice(원)].
// - 목록은 레거시와 같이 seq 큰 순서로 보인다. 새로 등록한 강좌(코드 없음)는 그 앞에 최근 등록 순으로 둔다.
// - 미리보기 이미지는 강좌에 등록한 썸네일(공개 과정 API imagePath)이다. 없으면 이미지 준비중 그림을 쓴다.
// - 교육비는 비환급 과정의 표시용이다. 환급과정은 공개 과정 API의 표준훈련비가 정본이다.
export const LEGACY_COURSES = {
  '06FEXJ': [4273, 1, 60000],
  '116S7S': [4204, 1, 87780],
  '1B1YVF': [4247, 1, 100000],
  '1JI71V': [4151, 1, 20000],
  '21IPJ6': [4275, 1, 30000],
  '2B84U0': [4239, 1, 100000],
  '2CXKDF': [4132, 1, 0],
  '2H5YTB': [4102, 0, 0],
  '2ZD50P': [4251, 1, 40000],
  '33P4A8': [4230, 1, 40000],
  '3F50J0': [4181, 1, 20000],
  '3K8Y22': [4238, 1, 100000],
  '3T6UN2': [4169, 1, 20000],
  '47DIZ7': [4222, 1, 117040],
  '4XQ42Y': [4263, 1, 129580],
  '4XY7FF': [4274, 1, 60000],
  '50AXPL': [4249, 1, 83600],
  '5I1722': [4206, 1, 129580],
  '5MYDXM': [4109, 1, 0],
  '60WRBP': [4202, 1, 125400],
  '69H5LJ': [4265, 1, 129580],
  '6CACJF': [4228, 1, 60000],
  '6YUJ26': [4225, 1, 87780],
  '72OF7N': [4276, 1, 30000],
  '7ECQW0': [4212, 1, 129580],
  '7SW1UD': [4226, 1, 83600],
  '867U6V': [4258, 1, 60000],
  '89UB00': [4112, 1, 0],
  '8M6P8N': [4180, 1, 40000],
  '8YIER4': [4240, 1, 100000],
  '99LZL2': [4217, 1, 15000],
  '9M4KPJ': [4124, 1, 0],
  '9X3OOS': [4279, 1, 129580],
  'AMFQAF': [4208, 1, 87780],
  'AS07L4': [4108, 1, 0],
  'B4PC8G': [4196, 1, 83600],
  'B9T5GK': [4255, 1, 10000],
  'BDTQ6P': [4243, 1, 100000],
  'BFO9AT': [4096, 1, 0],
  'BQBUOQ': [4092, 1, 0],
  'BVFO0A': [4269, 1, 129580],
  'CENANR': [4189, 1, 87780],
  'CIDK1P': [4127, 1, 0],
  'DBUMTH': [4224, 1, 83600],
  'DUAG44': [4193, 1, 129580],
  'E0U63R': [4241, 1, 100000],
  'E6QF80': [4253, 1, 10000],
  'E7JLM3': [4137, 1, 0],
  'E7Q9L7': [4094, 1, 0],
  'EBQUSY': [4119, 1, 0],
  'EQDC7S': [4097, 1, 0],
  'ESGBI6': [4210, 1, 129580],
  'F533Y6': [4256, 1, 10000],
  'F6DM3F': [4221, 1, 83600],
  'F8RXAW': [4244, 1, 100000],
  'FDHIDW': [4227, 1, 40000],
  'FUZZ16': [4134, 1, 129580],
  'FXPL8F': [4200, 1, 60000],
  'G039R0': [4192, 1, 87780],
  'G0TEG6': [4115, 1, 0],
  'GAGFUH': [4091, 1, 0],
  'GWJWJJ': [4267, 1, 87780],
  'GZORIU': [4260, 1, 129580],
  'H53RP7': [4129, 1, 0],
  'HGCJ13': [4213, 1, 129580],
  'HX5SD0': [4268, 1, 129580],
  'I4XEYM': [4111, 1, 0],
  'IBCK58': [4248, 1, 83600],
  'IHTKQ2': [4211, 1, 87780],
  'ITWA8D': [4174, 1, 40000],
  'J7XD4I': [4116, 1, 0],
  'JDU0PQ': [4259, 1, 87780],
  'JERSYK': [4135, 1, 0],
  'KF59D5': [4168, 1, 40000],
  'KOIQ9Q': [4157, 1, 20000],
  'KU16GT': [4142, 1, 0],
  'KYQBB0': [4123, 1, 0],
  'L9Q105': [4138, 1, 129580],
  'LTOG4O': [4232, 1, 100000],
  'LVTFO2': [4121, 1, 0],
  'MCC9M0': [4198, 1, 30000],
  'MJ6D05': [4150, 1, 40000],
  'N1CHLT': [4131, 1, 0],
  'N9L01K': [4280, 1, 129580],
  'NBJQQ0': [4242, 1, 100000],
  'O2IZTR': [4229, 1, 30000],
  'O9IF09': [4278, 1, 125400],
  'OL6WUV': [4186, 1, 40000],
  'OWRQ4K': [4220, 1, 129580],
  'OYMYNV': [4219, 1, 30000],
  'P2O5GS': [4146, 1, 10000],
  'PEW700': [4148, 1, 10000],
  'PW3393': [4136, 1, 129580],
  'QJDL1N': [4191, 1, 129580],
  'QR73KW': [4218, 1, 60000],
  'QXEC39': [4162, 1, 40000],
  'R2ASWX': [4140, 1, 129580],
  'R4MV2S': [4261, 1, 129580],
  'R7T6PT': [4209, 1, 129580],
  'S2S8XN': [4190, 1, 129580],
  'S7MXAR': [4271, 1, 87780],
  'SFBZ26': [4149, 1, 10000],
  'SK7AC8': [4250, 1, 83600],
  'SS1J1M': [4175, 1, 20000],
  'SXJOE0': [4257, 1, 30000],
  'SZJ897': [4215, 1, 60000],
  'T0KXZX': [4262, 1, 129580],
  'T30Q5V': [4266, 1, 87780],
  'T3QG2V': [4128, 1, 0],
  'T5U0RE': [4156, 1, 40000],
  'TDJ1EB': [4272, 1, 129580],
  'TI3H20': [4245, 1, 100000],
  'TM78CE': [4163, 1, 20000],
  'TO3HJ3': [4147, 1, 10000],
  'TRZHAE': [4203, 1, 87780],
  'TU8VK0': [4144, 1, 10000],
  'TUU1O7': [4277, 1, 83600],
  'U52KPQ': [4201, 1, 83600],
  'V0F3H0': [4254, 1, 10000],
  'V5Q68N': [4117, 1, 0],
  'V5VS6L': [4207, 1, 129580],
  'VLSGTZ': [4195, 1, 125400],
  'VV0PB6': [4246, 1, 100000],
  'W2QO4W': [4095, 1, 0],
  'WZJIJL': [4237, 1, 100000],
  'X4DRUO': [4197, 1, 30000],
  'YF6SI8': [4110, 1, 0],
  'YPZPIV': [4100, 0, 0],
  'YRITF1': [4125, 1, 87780],
  'YU8G9C': [4205, 1, 129580],
  'YYW1V0': [4141, 1, 129580],
  'Z536SN': [4120, 1, 0],
  'ZDECSF': [4188, 1, 87780],
  'ZGH8Q0': [4113, 1, 0],
  'ZIIPZL': [4114, 1, 0],
  'ZM2APK': [4214, 1, 129580],
  'ZMEPAZ': [4118, 1, 0],
  'ZZ7LF0': [4126, 1, 0],
}
